module.exports = __webpack_public_path__ + "static/img/BSV.32138ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/currencyIcon/BSV.png
// module id = F3Na
// module chunks = 1